<template>
  <div flex>
    <div class="enuo-breadcrumb">
      <slot />
    </div>
    <div flex-box="1" flex="main:center" class="enuo-container-sub-menu">
      <el-menu :default-active="active" class="el-menu-demo" mode="horizontal" @select="fnMenuSelect">
        <el-menu-item v-for="(item,index) in menus" :index="index+''" :key="index">
          <i v-if="item.icon" :class="item.icon"></i>
          <span slot="title">{{item.title}}</span>
        </el-menu-item>
      </el-menu>
    </div>
    <div class="enuo-container-sub-tool" flex-box="0">
      <slot name="actions" />
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {}
  },
  props: {
    menus: {
      type: Array,
      default: () => ([])
    },
    indexKey: {
      type: String,
      default: 'name'
    }
  },
  computed: {
    active () {
      let key = this.indexKey
      let route = this.$route[key]
      let index = -1
      for (let i = 0; i < this.menus.length; i++) {
        let el = this.menus[i]
        if (el.active !== undefined) {
          if (el.active === true) {
            index = i
          } else {
            index = route.indexOf(el.active) === 0 ? i : index
          }
        } else {
          index = route.indexOf(el[key]) === 0 ? i : index
        }
        if (index > -1) {
          break
        }
      }
      return index + ''
    }
  },
  methods: {
    fnMenuSelect (index, keyPath) {
      let i = parseInt(index)
      let menu = this.menus[i]
      let p = {}
      p[this.indexKey] = menu[this.indexKey]
      p.params = menu.params || {}
      p.query = menu.query || {}
      this.$router.push(p)
    }
  }
}
</script>
